<p-dialog
  [(visible)]="visible"
  [modal]="true"
  styleClass="w-full h-full lg:w-8/12 lg:h-fit"
  position="center"
  [draggable]="false"
  [resizable]="false"
  >
  <ng-template pTemplate="header">
    <h3 [textContent]="curStepTitle"></h3>
  </ng-template>
  <ng-template pTemplate="body" [formGroup]="trackingGroup" class="p-fluid">
    <!-- Profile completed confirmation step -->
    @if (isProfileCompletedStep) {
      <div class="text-center py-6">
        <i class="pi pi-check-circle text-green-500" style="font-size: 4rem"></i>
        <h2 class="text-gray-900 font-bold text-3xl mt-6 mb-4">
          {{ "registration_confirmation_title" | i18n }}
        </h2>
        <p
          class="text-gray-600 mb-8 text-xl px-8 mx-auto"
        [innerHTML]="
          (hasPurchasePreselected
            ? 'registration_confirmation_message_buy'
            : 'registration_confirmation_message'
          ) | i18n
        "
        ></p>
        @if (!hasPurchasePreselected) {
          <div
            class="flex flex-col gap-4 justify-center items-center"
            >
            <a
              [routerLink]="purchaseUrl"
              class="p-button p-button-lg p-button-success no-underline font-bold px-8 py-4 rounded-[var(--border-radius)]"
              >
              {{ "registration_btn_buy_plan" | i18n }}
            </a>
            <a
              (click)="stayFree()"
              class="cursor-pointer"
              >{{ "registration_stay_free" | i18n }}</a
              >
            </div>
          }
          @if (hasPurchasePreselected) {
            <div
              class="flex flex-col gap-4 justify-center items-center"
              >
              <p>
                <i class="pi pi-spin pi-spinner"></i>
                {{ "registration_redirect_to_shop" | i18n }}
              </p>
              <p>
                <small
                  ><a [routerLink]="purchaseUrl">{{
                  "registration_go_to_shop" | i18n
                }}</a></small
                >
              </p>
            </div>
          }
          <!--
          <p *ngIf="hasPurchasePreselected" class="text-primary font-medium mb-6">
            {{ "registration_redirect_to_shop" | i18n }}
          </p>
          <div
            class="flex flex-col gap-4 justify-center items-center"
            >
            <a
              [routerLink]="purchaseUrl"
              class="p-button p-button-lg p-button-success no-underline font-bold px-8 py-4 rounded-[var(--border-radius)]"
              >
              {{ "registration_btn_buy_plan" | i18n }}
            </a>
            <a
              *ngIf="!hasPurchasePreselected"
              (click)="stayFree()"
              class="cursor-pointer"
              >{{ "registration_stay_free" | i18n }}</a
              >
            </div>
            -->
          </div>
        }
        <!-- Wizard step 1 -->
        @if (
          !isProfileCompletedStep && curStepIndex === (profileCompleted() ? 1 : 0)
          ) {
          <div
            class="text-center height-100 flex flex-col justify-center items-center"
            >
            <img
              src="assets/img/logo.svg"
              width="100"
              alt="welcome"
              style="margin: 0 auto"
              />
            <div
              [innerHTML]="'delete_fist_login_one' | i18n"
              class="pt-6 ps-2 pe-2 lg:ps-6 lg:pe-6"
            ></div>
          </div>
        }
        <!-- Wizard step 2 -->
        @if (
          !isProfileCompletedStep && curStepIndex === (profileCompleted() ? 2 : 1)
          ) {
          <div
            class="height-100 flex flex-col justify-center items-center"
            >
            @if (!generatedApiKey) {
              <div class="lg:col-8">
                <h3>Create your first API keys pair</h3>
                <p>
                  For secure and proper <strong>SMTP configuration</strong> of your
                  email client or sending scripts, you need to generate a
                  <strong>dedicated pair of API keys</strong>.
                </p>
                <p>
                  The <strong>Consumer Key</strong> will act as your username, and the
                  <strong>Consumer Secret</strong> will be your password. Click the
                  button below to generate your keys instantly.
                </p>
                <p>
                  Please note that in <em>Settings > API Keys</em>, you will be able to
                  revoke the keys at any time or create new ones.
                </p>
                <p class="text-center">
                  <button
                    type="button"
                    pButton
                    [loading]="loadingApiKeyGeneration"
                    [disabled]="loadingApiKeyGeneration || C"
                    (click)="generateApiKey()"
                    [label]="'first_login_generate_apikey' | i18n"
                    icon="pi pi-plus"
                    class="p-button-success mb-6"
                  ></button>
                </p>
              </div>
            }
            <p-table></p-table>
            @if (generatedApiKey) {
              <div class="lg:col-10">
                <div
                  class="p-datatable-striped p-datatable-gridlines p-datatable p-component"
                  >
                  <div class="p-datatable-wrapper">
                    <h3>SMTP Configuration parameters</h3>
                    <table role="table" class="p-datatable-table mt-4">
                      <thead role="rowgroup" class="p-datatable-thead">
                        <tr>
                          <th>Parameter</th>
                          <th>Value</th>
                        </tr>
                      </thead>
                      <tbody role="rowgroup" class="p-element p-datatable-tbody">
                        <tr>
                          <td>
                            <span class="p-column-title">Parameter</span>
                            <span>SMTP Server</span>
                          </td>
                          <td>
                            <span class="p-column-title">Value</span>
                            <span>pro.eu.turbo-smtp.com</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="p-column-title">Parameter</span>
                            <span>SMTP Authentication</span>
                          </td>
                          <td>
                            <span class="p-column-title">Value</span>
                            <span>Enabled</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="p-column-title">Parameter</span>
                            <span>SMTP Username</span>
                          </td>
                          <td>
                            <span class="p-column-title">Value</span>
                            <span>
                              <div>Consumer Key</div>
                              <div class="p-inputgroup">
                                <input
                                  type="text"
                                  pInputText
                                  [value]="generatedApiKey.consumerKey"
                                  readonly
                                  class="bg-gray-100"
                                  />
                                <button
                                  type="button"
                                  pButton
                                  icon="pi pi-copy"
                                  class="p-button-outlined"
                                  (click)="copyToClipboard(generatedApiKey.consumerKey)"
                                ></button>
                              </div>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="p-column-title">Parameter</span>
                            <span>SMTP Password</span>
                          </td>
                          <td>
                            <span class="p-column-title">Value</span>
                            <span>
                              <div>Consumer Secret</div>
                              <div class="p-inputgroup">
                                <input
                                  type="text"
                                  pInputText
                                  [value]="generatedApiKey.consumerSecret"
                                  readonly
                                  class="bg-gray-100"
                                  />
                                <button
                                  type="button"
                                  pButton
                                  icon="pi pi-copy"
                                  class="p-button-outlined"
                          (click)="
                            copyToClipboard(generatedApiKey.consumerSecret)
                          "
                                ></button>
                              </div>
                              <p-message severity="info">
                                  <span class="custom-message flex gap-4">
                                    <strong class="pi pi-arrow-up mt-1"></strong>
                                    <div
                              [innerHTML]="
                                'settings_apikeys_apikey_new_security' | i18n
                              "
                                    ></div>
                                  </span>
</p-message>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="p-column-title">Parameter</span>
                            <span>SMTP Ports</span>
                          </td>
                          <td>
                            <span class="p-column-title">Value</span>
                            <span>
                              <span class="flex gap-2">
                                <span class="grow">SSL<br />465, 25025</span>
                                <span class="grow"
                                  >non-SSL<br />25, 587, 2525</span
                                  >
                                </span>
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </ng-template>
        <ng-template pTemplate="footer">
          @if (!isProfileCompletedStep) {
            <div
              class="lg:flex lg:justify-between lg:flex-wrap"
              >
              <!-- Close button for each step (except when API key is generated) -->
              <div class="lg:mb-0 mb-2 text-center">
                @if (!generatedApiKey) {
                  <button
                    type="button"
                    class="p-button-link p-button-secondary"
                    pButton
                    icon="pi pi-times"
                    (click)="closeModalAndDisableTooltip()"
                    [label]="'first_login_close_dont_show' | i18n"
                  ></button>
                }
              </div>
              <div class="flex gap-2 justify-between ms-auto">
                @if (!isFirstStep) {
                  <button
                    type="button"
                    class="p-button-outlined"
                    pButton
                    icon="pi pi-chevron-left"
                    iconPos="left"
                    (click)="goBack()"
                    [label]="'button_back' | i18n"
                  ></button>
                }
                @if (!isLastStep) {
                  <button
                    type="button"
                    pButton
                    icon="pi pi-chevron-right"
                    class="ms-auto"
                    iconPos="right"
                    (click)="goNext()"
                    [label]="'button_next' | i18n"
                  ></button>
                }
                @if (isLastStep) {
                  <button
                    type="button"
                    [loading]="loadingSave"
                    pButton
                    icon="pi pi-check"
                    iconPos="right"
                    (click)="save()"
                    [label]="'button_close' | i18n"
                  ></button>
                }
              </div>
            </div>
          }
        </ng-template>
      </p-dialog>
